import { Field } from 'redux-form';

import { SelectField } from 'common/components/forms';
import {
  convertISODateTimeStringToISODate,
  dateFormat,
  timeFormat
} from 'common/helpers/dateHelper';

const ReservationTime = (props) => {
  const { settings } = props;
  return (
    <Field
      name="reservationTime"
      component={SelectField}
      optionArray={reservationTime(settings)}
      label="Reservation Time"
      className="c7-form-label__reservation-time"
      required
    />
  );
};

const reservationTime = (settings) => {
  const array = [{ value: '', option: '' }];
  const now = new Date();

  const startTime = convertISODateTimeStringToISODate(
    dateFormat(now, settings, 'isoDate'),
    settings.data.reservations.availabilityStartTime,
    settings
  );
  const endTime = convertISODateTimeStringToISODate(
    dateFormat(now, settings, 'isoDate'),
    settings.data.reservations.availabilityEndTime,
    settings
  );
  const newStartTime = new Date(startTime);
  const newEndTime = new Date(endTime);
  let loopTime;
  for (
    loopTime = newStartTime.getTime();
    loopTime <= newEndTime.getTime();
    loopTime += 1000 * 60 * 30
  ) {
    const loopDay = new Date(loopTime);
    // use loopDay as you wish
    array.push({
      value: timeFormat(loopDay.toISOString(), settings, 'isoDate'),
      option: timeFormat(loopDay.toISOString(), settings)
    });
  }

  return array;
};

export default ReservationTime;
